import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditAllotParkModal = ({ show, handleClose, onRowSelect }) => {


  const [searchYear1, setSearchYear1] = useState();
  const [searchStd, setSearchStd] = useState();

  const [searchResults, setSearchResults] = useState([]);
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [ddlStandards, setddlStandards] = useState([]);

  useEffect(() => {

    const fetchLists = async () => {
      try {
        const [yearRes, stdRes] = await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_years`),
            axios.get(`${BASE_URL}/api/ddl_all_standards`),
        ]);

        setDdlAcademicYears(yearRes.data);
        setddlStandards(stdRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  const handleSearch = async () => {

    try {
      const response = await axios.get(`${BASE_URL}/api/get_fees_struct`, {
        params: {p_Std_Id: searchStd || 0, p_Year1: searchYear1 || 0},
      });

      setSearchResults(response.data);

    } catch (error) {
      console.error('Search failed:', error);
    }

  };

  const handleClear = async () => {
    setSearchStd('');
    setSearchYear1('');
    setSearchResults([]);

  }
  
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Select Fees Structure - Edit</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">

            {/* Section Dropdown */}
            <Form.Group className="col-md-4">
                <Form.Select
                  value={searchStd}
                  onChange={(e) => setSearchStd(e.target.value)}>
                <option value="">--Select Standard--</option>
                {ddlStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="col-md-4">
              <Form.Select
                value={searchYear1}
                onChange={(e) => setSearchYear1(e.target.value)}>
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <div className="col-md-2">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-2">
                 <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '5%', textAlign: 'left' }}>Year</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Standard</th>
                <th style={{ width: '10%', textAlign: 'center' }}>Division</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="3" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.years}</td>
                    <td style={{ textAlign: 'left' }}>{row.stdname}</td>
                    <td style={{ textAlign: 'left' }}>{row.divname}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAllotParkModal;
